var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "19 5.5 238.5 188.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 131.975,
    y1: 30.917,
    x2: 179.208,
    y2: 30.917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71ee6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#0cc32e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.2 13.4l-47.2 35v-35z",
    fill: "url(#a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 20.673,
    y1: 46.25,
    x2: 118.448,
    y2: 46.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71ee6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#0cc32e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.4 13.4v41.5L85.8 79.1V46H20.7V13.4z",
    fill: "url(#b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 154.775,
    y1: -2.741,
    x2: 71.577,
    y2: 222.482
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#008eb6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.2 71.1v112l-31.5-.1V94.6z",
    fill: "url(#c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 222.004,
    y1: 20.042,
    x2: 122.076,
    y2: 290.552,
    gradientTransform: "rotate(-90 313.55 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#008eb6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256.4 117.5H132.5V149h96.3z",
    fill: "url(#d)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 184.391,
    y1: 7.199,
    x2: 96.39,
    y2: 245.425
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#008eb6"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 40.6v107.7H132V64.6z",
    fill: "url(#e)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9 0 0 1 121.975 182.129)",
    fill: "#00aed7",
    fontFamily: "IRHoma",
    fontSize: 34.743
  }, "TopLearn")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.13a19821d076e80bf0e48c169afd7a43.svg";
export { ForwardRef as ReactComponent };